import React, { useMemo, useState } from "react";
import { Grid, Typography } from "@mui/material";
import Chart from "./components/Chart";
import "./Home.css";

export const isValidNumber = (value) =>
  value !== null && value !== undefined && !isNaN(value);

export const formatAcumulador = (value) => {
  if (!isValidNumber(value) || value < 0) {
    return { value: "--", unit: "" };
  }

  const numericValue = Number(value);

  if (numericValue >= 100000) {
    return {
      value: (numericValue / 1000).toFixed(2),
      unit: "Ton O2",
    };
  }

  if (numericValue >= 1000) {
    return {
      value: Math.floor(numericValue).toLocaleString("es-CL"),
      unit: "kg O2",
    };
  }

  return {
    value: numericValue.toFixed(2),
    unit: "kg O2",
  };
};

const Home = ({ data, translate }) => {
  const bg =
    "linear-gradient(145deg, rgb(18, 25, 38) 0%, rgb(28, 45, 68) 100%)";
  const [visible, setVisible] = useState({
    cumulant: true,
    flow_rate: true,
  });

  const toggleDataset = (key) => {
    setVisible((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const chartData = useMemo(() => {
    const sensorData = data?.sensor_data;
    if (!sensorData) return [];

    const sensorKey = Object.keys(sensorData)[0];
    const sensor = sensorData[sensorKey];
    if (!sensor) return [];

    return sensor.TS.map((ts, index) => ({
      TS: ts,
      cumulant: Number(sensor.cumulant[index]),
      flow_rate: Number(sensor.flow_rate[index]),
      connection_status: Boolean(sensor.connection_status[index]),
    }));
  }, [data]);

  const lastValues = useMemo(() => {
    if (!chartData.length) return null;

    const last = chartData[chartData.length - 1];
    return {
      cumulant: last.cumulant,
      flow_rate: last.flow_rate,
      connection_status: last.connection_status,
      TS: last.TS,
    };
  }, [chartData]);

  const minutesAgo = lastValues?.TS
    ? Math.max(0, Math.round((Date.now() - new Date(lastValues.TS)) / 60000))
    : 0;

  const acumuladorFormatted = formatAcumulador(lastValues?.cumulant);

  return (
    <Grid
      container
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
    >
      <div className="barco" style={{ background: bg }}>
        {lastValues && (
          <div className="status-container">
            <div
              className={`status-left-nanoox-bolt ${
                lastValues.connection_status ? "status-ok" : "status-error"
              }`}
            >
              <Typography variant="h4" className="typo-status">
                {lastValues.connection_status
                  ? translate("connected")
                  : translate("no_communication")}
              </Typography>

              <span className="status-dot" />
            </div>

            <Typography variant="caption" className="ultima-lectura">
              {translate("last_reading_ago_minutes", { minutesAgo })}
            </Typography>
          </div>
        )}

        <div className="home-nanoox-bolt">
          <Chart data={chartData} visible={visible} translate={translate} />
        </div>

        <div className="divider-soft" />

        {lastValues && (
          <div className="metrics-wrapper">
            <Grid container justifyContent="space-around">
              <Grid item>
                <div
                  className={`metric-card ${
                    visible.flow_rate ? "active" : "inactive"
                  }`}
                  onClick={() => toggleDataset("flow_rate")}
                >
                  <Typography variant="subtitle2" className="subtitle2">
                    {translate("o2_instantaneous")} [ g/min ]
                  </Typography>
                  <Typography variant="h4" color="#3b82f6" className="value-bolt">
                    {lastValues.flow_rate != null && lastValues.flow_rate >= 0
                      ? lastValues.flow_rate.toFixed(2)
                      : "--"}
                  </Typography>
                  <Typography variant="caption" className="value-visible">
                    {visible.flow_rate
                      ? translate("visible")
                      : translate("hidden")}
                  </Typography>
                </div>
              </Grid>

              <Grid item>
                <div
                  className={`metric-card ${
                    visible.cumulant ? "active" : "inactive"
                  }`}
                  onClick={() => toggleDataset("cumulant")}
                >
                  <Typography variant="subtitle2" className="subtitle2">
                    {translate("o2_cumulative")} [ {acumuladorFormatted.unit} ]
                  </Typography>
                  <Typography variant="h4" color="#22c55e" className="value-bolt">
                    {lastValues.cumulant != null && lastValues.cumulant >= 0
                      ? lastValues.cumulant.toFixed(2)
                      : "--"}
                  </Typography>
                  <Typography variant="caption" className="value-visible">
                    {visible.cumulant
                      ? translate("visible")
                      : translate("hidden")}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    </Grid>
  );
};

export default Home;
